"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _HightRiskChartComponent = _interopRequireDefault(require("./HightRiskChartComponent"));
require("./HightRiskChartWithLabelComponent.css");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _reactI18next = require("react-i18next");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('margin-risk-chart');
var HightRiskChartWithLabelComponent = function HightRiskChartWithLabelComponent(_ref) {
  var level = _ref.level,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'big' : _ref$size,
    riskNumber = _ref.riskNumber,
    label = _ref.label;
  var riskColorClasses = {
    'Very Low': baseClasses('level--very-low'),
    Low: baseClasses('level--low'),
    Medium: baseClasses('level--medium'),
    High: baseClasses('level--high'),
    'Very High': baseClasses('level--very-high'),
    'Margin Call': baseClasses('level--margin-call'),
    'In Liquidation': baseClasses('level--in-liquidation')
  };
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('container')
  }, /*#__PURE__*/_react["default"].createElement(_HightRiskChartComponent["default"], {
    level: level,
    size: size
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('label-container')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(baseClasses('level', size), " ").concat(riskColorClasses[label] || '')
  }, riskNumber), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(baseClasses('label-risk'), " ").concat(riskColorClasses[label] || '')
  }, t(label).toUpperCase())));
};
var _default = exports["default"] = HightRiskChartWithLabelComponent;